import { create } from '@theme/create';
import { text } from '@theme/theme.text';

export const themed = create(
  new (function () {
    this.header = {
      display: 'flex',
      width: '100%',
      flexDirection: ['column', null, null, 'row'],
      marginBottom: 14,
      gap: [12, null, null, 0],
      '@media only screen and (max-width: 767px)': {
        marginBottom: 0,
      },
    };

    this.contentWrapper = {
      flex: 1,
    };

    this.heading = (tag) => ({
      width: '100%',
      variant: `text.${tag}`,
      mb: [10, null, null, 0],
      flex: 1,
      px: 0,
      '@media only screen and (max-width: 767px)': {
        px: 8,
      },
    });

    this.cta = {
      alignSelf: ['flex-start', null, null, 'center'],
      flexShrink: 0,
      '@media only screen and (max-width: 767px)': {
        mx: 8,
      },
    };
  })()
);